module.exports = __webpack_public_path__ + "img/BOBO Coin Laundry.34da0671.svg";